import { render, staticRenderFns } from "./BaseCircularLoader.vue?vue&type=template&id=72173e88&scoped=true&"
import script from "./BaseCircularLoader.vue?vue&type=script&lang=js&"
export * from "./BaseCircularLoader.vue?vue&type=script&lang=js&"
import style0 from "./BaseCircularLoader.vue?vue&type=style&index=0&id=72173e88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72173e88",
  null
  
)

export default component.exports